<script>
    import { tracks, defaults } from "../file_variables"
    import { TrackButton } from "../components"

    export let trackPlaying
    export let currentPlayingTrack

    function updateTrack(track) {
        trackPlaying=true
        currentPlayingTrack=track
    }

    function stopTrack() {
        trackPlaying=false
        currentPlayingTrack=""
    }
</script>

<img class="bx--tracks-cover" src={defaults.cover_image} alt={defaults.release_name}/>
<div class="bx--tracks-heading">
    {defaults.release_name}
</div>
<div class="bx--all-tracks">
    {#each tracks as track }
        {#if track.name == currentPlayingTrack.name}
            <TrackButton on:click={()=>stopTrack()}>
                Stop
            </TrackButton>
        {:else}
            <TrackButton on:click={()=>updateTrack(track)}>
                {track.name}
            </TrackButton>
        {/if}
    {/each}
</div>